module.exports = __webpack_public_path__ + "img/zhe.41ff5e05.png";